import {
  IGetWhitelistParamsResponse,
  ReplaceWhitelistResponse,
  UserEndpointTokenMode,
  WhitelistItem,
  WhitelistToReplace,
} from 'multirpc-sdk';

const getList = (whitelist: WhitelistToReplace, type: UserEndpointTokenMode) =>
  Object.entries(whitelist).map<WhitelistItem>(([blockchain, list]) => ({
    blockchain,
    list,
    type,
  }));

export const mapReplaceWhitelistResponse = ({
  address = {},
  ip = {},
  prohibit_by_default,
  referer = {},
  whitelist,
}: ReplaceWhitelistResponse): IGetWhitelistParamsResponse => {
  const ipList = getList(ip, UserEndpointTokenMode.IP);
  const refererList = getList(referer, UserEndpointTokenMode.REFERER);
  const addressList = getList(address, UserEndpointTokenMode.ADDRESS);

  return {
    lists: [...ipList, ...refererList, ...addressList],
    prohibit_by_default,
    whitelist,
  };
};
